import { Grid } from "@mui/material";
import { useIntl } from "react-intl";

import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { PonziDepositStatus, TokenType, IPonziDepositSearchDto } from "@framework/types";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

interface IPonziDepositSearchFormProps {
  initialValues: Partial<IPonziDepositSearchDto>;
}

export const PonziDepositSearchForm = (props: IPonziDepositSearchFormProps) => {
  const { initialValues } = props;

  const { formatMessage } = useIntl();

  const { ponziDepositStatus, deposit, reward } = initialValues;
  const fixedValues = { ponziDepositStatus, deposit, reward };

  return (
    <SearchWithFilters initialValues={fixedValues as any}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 12 }}>
          <SelectInput name="ponziDepositStatus" options={PonziDepositStatus} multiple />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <SelectInput
            multiple
            name="deposit.tokenType"
            options={TokenType}
            label={formatMessage({ id: "form.labels.deposit" })}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <SelectInput
            multiple
            name="reward.tokenType"
            options={TokenType}
            label={formatMessage({ id: "form.labels.reward" })}
          />
        </Grid>
      </Grid>
    </SearchWithFilters>
  );
};
